import { z } from 'zod';

const cuisineEntryWire = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  valence: z.enum(['favorite', 'avoid']),
});
const refEntryWire = z.object({ id: z.string(), slug: z.string(), name: z.string() });

export const tasteProfileWireSchema = z.object({
  cuisines: z.array(cuisineEntryWire),
  allergens: z.array(refEntryWire),
  dietaryProfiles: z.array(refEntryWire),
});
export type TasteProfileWire = z.infer<typeof tasteProfileWireSchema>;
